import axios from "axios";
import { getToken } from "../functions/localStorage";

export const SERVER_AXIOS = axios.create({
    // baseURL: "http://localhost:5000/api/v4"
    baseURL: "https://flexgrade-be.onrender.com/api/v5"
    // baseURL:"https://flexgrade-be.onrender.com/api/v1"
})

export const EMAIL_SERVER_AXIOS = axios.create({
    baseURL:"https://flexgrade-be.onrender.com/api/v1"
})

export const getHeaders = (token) => ({
    Authorization: `Bearer ${token ?? getToken()}`,
});

